<template>
    <div class="w-full animate-pulse">
        <div class="flex flex-col gap-4 mb-6 mt-10 sm:flex-row sm:items-center sm:gap-4">
            <div class="flex w-full flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div class="flex-1">
                    <div class="inline-flex w-full sm:w-auto rounded-md bg-slate-200 p-1 shadow-sm">
                        <div class="h-10 sm:w-20 rounded"></div>
                        <div class="h-10 sm:w-20 rounded"></div>
                        <div class="h-10 sm:w-20 rounded"></div>
                    </div>
                </div>
                <div class="inline-flex w-full sm:w-auto rounded-md bg-slate-200 p-1 shadow-sm sm:ml-4">
                    <div class="h-10 sm:w-20 rounded"></div>
                    <div class="h-10 sm:w-20 rounded"></div>
                    <div class="h-10 sm:w-20 rounded"></div>
                </div>
            </div>
        </div>

        <h2 class="mb-4 h-5 w-32 bg-slate-200 rounded"></h2>
        <div class="grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-6 gap-3">
            <div
                v-for="i in 8"
                :key="i"
                class="rounded border border-slate-200 bg-white px-4 py-3 flex flex-col gap-2"
            >
                <div class="h-3 w-16 bg-slate-200 rounded"></div>
                <div class="h-6 w-12 bg-slate-200 rounded"></div>
            </div>
        </div>

        <div class="flex flex-col gap-4 mt-6 sm:flex-row sm:items-center sm:gap-4">
            <div class="flex w-full flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div class="flex-1 flex gap-2"></div>
                <div class="inline-flex w-full sm:w-auto rounded-md bg-slate-200 p-1 shadow-sm sm:ml-4">
                    <div class="h-10 flex-1 sm:w-20 rounded"></div>
                    <div class="h-10 flex-1 sm:w-20 rounded"></div>
                </div>
            </div>
        </div>

        <div class="mt-2 rounded-sm border border-slate-200 bg-white p-4">
            <div class="h-4 w-32 bg-slate-200 rounded mb-4"></div>
            <div class="h-[350px] w-full bg-slate-100 rounded"></div>
        </div>

        <div class="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <div
                v-for="section in 6"
                :key="section"
                class="rounded-sm border border-slate-200 bg-white p-4"
            >
                <div class="h-4 w-40 bg-slate-200 rounded mb-4"></div>
                <div class="h-[280px] w-full bg-slate-100 rounded"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SkeletonReportItem',
}
</script>
